import { useEffect, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import {
  Box,
  Card,
  Table,
  Switch,
  Button,
  TableBody,
  Container,
  TableContainer,
  TablePagination,
  FormControlLabel,
} from '@mui/material';

import { useSnackbar } from 'notistack';
import { observer } from 'mobx-react-lite';
import MyDialog from 'src/components/MyDialog';
import StatusDelete from './ShopContractTypeDelete';

import ShopContractTypeTableRow from './ShopContractTypeTableRow';
import ShopContractTypeTableToolbar from './ShopContractTypeTableToolbar';
import PermissionBasedGuard from 'src/guards/PermissionBasedGuard';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import Scrollbar from 'src/components/Scrollbar';
import { TableHeadCustom, TableEmptyRows, TableNoData } from 'src/components/table';
import useSettings from 'src/hooks/useSettings';
import useTable, { getComparator, emptyRows } from 'src/hooks/useTable';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { IShopContractType } from 'src/@types/Choqorak/Settings/ShopContractType';
import Page from 'src/components/Page';
import { useStore } from 'src/stores/store';

// ----------------------------------------------------------------------

export default observer(function ShopContractTypeList() {
  const { ShopContractTypeStore } = useStore();
  const { translate } = useLocales();
  const {
    loadShopContractType,
    ShopContractTypeList,
    ShopContractTypeRegistry,
    totalRecord,
    ShopContractTypeSearch,
    deleteShopContractType,
    getShopContractTypeFromRegistry,
    setOpenCloseDialog,
    openDialog,
  } = ShopContractTypeStore;
  const {
    dense,
    page,
    order,
    orderBy,
    rowsPerPage,
    setPage,
    onSort,
    onChangeDense,
    onChangeRowsPerPage,
  } = useTable();

  const { themeStretch } = useSettings();

  const [filterName, setFilterName] = useState('');

  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const [ShopContractTypeId, setShopContractTypeId] = useState<number>(0);
  const TABLE_HEAD = [
    { id: 'ID', label: `${translate('GeneralFields.Id')}`, align: 'left' },
    { id: 'englishName', label: `${translate('GeneralFields.EnglishName')}`, align: 'left' },
    { id: 'pashtoName', label: `${translate('GeneralFields.PashtoName')}`, align: 'left' },
    { id: 'dariName', label: `${translate('GeneralFields.DariName')}`, align: 'left' },
    { id: 'code', label: `${translate('GeneralFields.Code')}`, align: 'left' },
    { id: '', label: `${translate('GeneralFields.Action')}` },
  ];
  const handleFilterName = (filterName: string) => {
    setFilterName(filterName);
    setPage(0);
    if (filterName.length > 1) {
      ShopContractTypeSearch({
        pageIndex: 0,
        pageSize: rowsPerPage,
        searchBy: filterName,
        //dariName: filterName,
      });
    } else if (filterName === '') {
      ShopContractTypeSearch({ pageIndex: 0, pageSize: rowsPerPage });
    }
  };

  const handleOpenConfirm = (id: number) => {
    setOpenCloseDialog();
    setShopContractTypeId(id);
  };

  const handleCloseConfirm = () => {
    setOpenCloseDialog();
  };
  const handleEditRow = (id: number) => {
    getShopContractTypeFromRegistry(id);
    navigate(PATH_DASHBOARD.ShopContractType.edit);
  };

  // const handleDelete = () => {
  //   deleteShopContractType(ShopContractTypeId)
  //     .then(() => {
  //       setOpenConfirm(false);
  //       enqueueSnackbar('Delete  success!');
  //       setShopContractTypeId(0);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       enqueueSnackbar(`${translate('Tostar.DeleteFailed')}`, {
  //         variant: 'error',
  //       });
  //       setOpenConfirm(false);
  //       setShopContractTypeId(0);
  //     });
  // };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    loadShopContractType({ pageIndex: newPage, pageSize: rowsPerPage });
  };
  const handlePageSizeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangeRowsPerPage(event);
    let pageZize = parseInt(event.target.value);
    loadShopContractType({ pageIndex: 0, pageSize: pageZize });
  };
  useEffect(() => {
    if (ShopContractTypeRegistry.size <= 1) {
      loadShopContractType({ pageIndex: 0, pageSize: rowsPerPage });
    }
  }, []);

  const dataFiltered = applySortFilter({
    tableData: ShopContractTypeList,
    comparator: getComparator(order, orderBy),
    filterName: '',
  });

  const denseHeight = dense ? 52 : 72;

  const isNotFound = !dataFiltered.length && !!filterName;

  return (
    <Page title={translate('ShopContractType.Title')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('ShopContractType.ShopContractTypeList')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },

            { name: `${translate('ShopContractType.ShopContractTypeList')}` },
          ]}
          // action={
          //   <>
          //     <PermissionBasedGuard permissions={['ContractType-Create']}>
          //       <Button
          //         variant="contained"
          //         startIcon={<Iconify icon="eva:plus-fill" />}
          //         component={RouterLink}
          //         to={PATH_DASHBOARD.ShopContractType.new}
          //       >
          //         {translate('CRUD.Create')}
          //       </Button>
          //     </PermissionBasedGuard>
          //   </>
          // }
        />

        <Card>
          <ShopContractTypeTableToolbar filterName={filterName} onFilterName={handleFilterName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 960, position: 'relative' }}>
              <Table size={dense ? 'small' : 'medium'}>
                <TableHeadCustom
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={totalRecord}
                  onSort={onSort}
                />

                <TableBody>
                  {dataFiltered
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <ShopContractTypeTableRow
                        key={row.id}
                        row={row}
                        index={index}
                        onDeleteRow={() => handleOpenConfirm(row.id!)}
                        onEditRow={() => handleEditRow(row.id!)}
                      />
                    ))}

                  <TableEmptyRows
                    height={denseHeight}
                    emptyRows={emptyRows(page, rowsPerPage, totalRecord)}
                  />

                  <TableNoData isNotFound={isNotFound} />
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <Box sx={{ position: 'relative' }}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]}
              component="div"
              labelRowsPerPage={translate('Pagination.RowsPerPage')}
              count={totalRecord}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} ${translate('Pagination.Of')} ${count}`
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handlePageSizeChange}
            />
            <MyDialog
              open={openDialog}
              onClose={handleCloseConfirm}
              title={translate('CRUD.DeleteTitle')}
              size="md"
            >
              <StatusDelete id={ShopContractTypeId} />
            </MyDialog>
            <FormControlLabel
              control={<Switch checked={dense} onChange={onChangeDense} />}
              label={translate('Pagination.Dense')}
              sx={{ px: 3, py: 1.5, top: 0, position: { md: 'absolute' } }}
            />
          </Box>
        </Card>
      </Container>
    </Page>
  );
});

// ----------------------------------------------------------------------

function applySortFilter({
  tableData,
  comparator,
  filterName,
}: {
  tableData: IShopContractType[];
  comparator: (a: any, b: any) => number;
  filterName: string;
}) {
  const stabilizedThis = tableData.map((el, index) => [el, index] as const);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  tableData = stabilizedThis.map((el) => el[0]);

  if (filterName) {
    tableData = tableData.filter(
      (item: Record<string, any>) =>
        item.searchBy.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
    );
  }

  return tableData;
}
